import React from "react";
import { Link, useNavigate } from "react-router-dom";

const UnAuthorized = () => {
    const navigate = useNavigate();
    return (
        <>
            <div className='card basic-data-table'>
                <div className='card-body py-60 px-32 text-center'>
                    <img src='assets/images/extra/access.png' alt='' className='mb-24' />
                    <h6 className='mb-16'>Access Denied</h6>
                    <p className='text-secondary-light'>
                        You do not have authorization to get to this page.
                    </p>
                    <Link className='btn btn-primary-600 radius-8 px-20 py-11' onClick={() => navigate(-1)}>
                        Go Back
                    </Link>
                </div>
            </div>

        </>
    );
};

export default UnAuthorized;
